import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  sb: any;

  constructor( private snackBar: MatSnackBar) { }

  showFormErrors() {
    this.sb = this.snackBar.open('Per favore verifica che i dati inseriti siano corretti!', 'OK', {
      duration: 3500
    })
  }
}
